module.exports = __webpack_public_path__ + "static/media/support3.3f9d5d90.png";